export default __webpack_public_path__ + "static/media/xmas_2023-bm.fc2692fc.jpg";